import { Stack } from "@mui/material";
import { UlList } from "./UlList";
import { H4Component } from "./H4Component";

export const PlaybookList = ({
  title,
  items,
}: {
  title: string;
  items: string[];
}) => {
  if (!items || items.length === 0) return null;
  return (
    <Stack gap="8px">
      {title && <H4Component text={title} color={"#024760"} />}
      <UlList text={[]} items={items} />
    </Stack>
  );
};
